// extracted by mini-css-extract-plugin
export default {"download":"download-TqIxd","disabled":"disabled-UlRjr","toggler":"toggler-ixBQE","menu":"menu-TerPs"};